<template>
    <ButtonPopup
        :disabled="disabled"
        :title="$t('Align')"
        :button-class="alignmentButtonStyleClass"
        popup-class="p-0 pt-2 pl-2 popup-content">
        <FormatAlignJustifyIcon v-if="editor.isActive({ textAlign: 'justify' })" size="16"/>
        <FormatAlignRightIcon v-else-if="editor.isActive({ textAlign: 'right' })" size="16"/>
        <FormatAlignCenterIcon v-else-if="editor.isActive({ textAlign: 'center' })" size="16"/>
        <FormatAlignLeftIcon v-else size="16"/>
        <template #popup="{ close }">
            <button
                v-if="toolbarOptions.includes('left')"
                class="tiptap-btn"
                type="button"
                :disabled="!editor.can().chain().focus().setTextAlign('left').run()"
                :class="{ 'is-active': editor.isActive({ textAlign: 'left' }) }"
                @click="editor.chain().focus().setTextAlign('left').run(); close()">
                <FormatAlignLeftIcon size="16"/>
            </button>
            <button
                v-if="toolbarOptions.includes('center')"
                class="tiptap-btn"
                type="button"
                :disabled="!editor.can().chain().focus().setTextAlign('center').run()"
                :class="{ 'is-active': editor.isActive({ textAlign: 'center' }) }"
                @click="editor.chain().focus().setTextAlign('center').run(); close()">
                <FormatAlignCenterIcon size="16"/>
            </button>
            <button
                v-if="toolbarOptions.includes('right')"
                class="tiptap-btn"
                type="button"
                :disabled="!editor.can().chain().focus().setTextAlign('right').run()"
                :class="{ 'is-active': editor.isActive({ textAlign: 'right' }) }"
                @click="editor.chain().focus().setTextAlign('right').run(); close()">
                <FormatAlignRightIcon size="16"/>
            </button>
            <button
                v-if="toolbarOptions.includes('justify')"
                class="tiptap-btn"
                type="button"
                :disabled="!editor.can().chain().focus().setTextAlign('justify').run()"
                :class="{ 'is-active': editor.isActive({ textAlign: 'justify' }) }"
                @click="editor.chain().focus().setTextAlign('justify').run(); close()">
                <FormatAlignJustifyIcon size="16"/>
            </button>
        </template>
    </ButtonPopup>
</template>

<script>
import {Editor} from '@tiptap/vue-2';

import ButtonPopup from '@/common/components/button-popup/ButtonPopup.vue';
import FormatAlignJustifyIcon from '@/common/components/svg-icons/FormatAlignJustifyIcon.vue';
import FormatAlignLeftIcon from '@/common/components/svg-icons/FormatAlignLeftIcon.vue';
import FormatAlignRightIcon from '@/common/components/svg-icons/FormatAlignRightIcon.vue';
import FormatAlignCenterIcon from '@/common/components/svg-icons/FormatAlignCenterIcon.vue';

export default {
    name: 'MenuBarAlignmentButton',

    props: {
        editor: {
            type: Editor,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        toolbarOptions: {
            type: Array,
            default: () => ['left', 'center', 'right', 'justify']
        }
    },

    computed: {
        alignmentButtonStyleClass() {
            let styleClass = 'tiptap-btn';

            if (['left', 'center', 'right', 'justify'].some(align => this.editor.isActive({ textAlign: align }))) {
                styleClass = styleClass + ' is-active';
            }

            return styleClass;
        }
    },
    components: {
        FormatAlignCenterIcon,
        ButtonPopup,
        FormatAlignRightIcon,
        FormatAlignLeftIcon,
        FormatAlignJustifyIcon
    }
};
</script>
